// extracted by mini-css-extract-plugin
export default {"form":"QfjVk","button":"cdSnL","preloader":"V9v1L","input":"tPGkx","checkbox":"dvz8T","tooltip":"JStTV"};